import Vue from 'vue'
import '../assets/styles/element-variables.scss'
import {
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Image,
  Input,
  InputNumber,
  Link,
  Loading,
  Menu,
  MenuItem,
  Message,
  MessageBox,
  Notification,
  Option,
  Pagination,
  Popover,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Select,
  Step,
  Steps,
  Submenu,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Upload
} from 'element-ui'

Vue.use(Button)
Vue.use(Cascader)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Image)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Link)
Vue.use(Loading.directive)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Rate)
Vue.use(Row)
Vue.use(Select)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Submenu)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Upload)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
